import React from "react";
import investorimg1 from "../../img/investors/investorimg1.png";
import "./InvestorLanding.css";

function InvestorLanding() {
  return (
    <div className="InvestorLanding">
      <div className="InvestorLanding__leftblock">
        <h1>investors</h1>
        <p>
          With over 50 years of successful experience in Costa Blanca, we have a
          deep understanding of the local landscape and a proven track record of
          excellence. Our passion for providing the best quality and dedication
          to detail ensures that every villa we build is a masterpiece of design
          and functionality. <br />
          <br />
          From charming rustic retreats to sleek modern sanctuaries, our villas
          are the epitome of luxury living.
        </p>
      </div>
      <div className="InvestorLanding__rightblock">
        <img src={investorimg1} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
    </div>
  );
}

export default InvestorLanding;
